setTimeout(function() {
  if ($('#gcpRoot').length) {
    addHeader();
  }
}, 1000);

function addHeader() {
  if ($('html[lang="en"]').length) {
    $('#gcpRoot').prepend('<header class="collection-title-header"><div class="collection-title page-title"><div class="breadcrumb-navigation"></div><h1 class="label">Gift card</h1></div></header>')
  } else {
    $('#gcpRoot').prepend('<header class="collection-title-header"><div class="collection-title page-title"><div class="breadcrumb-navigation"></div><h1 class="label">Carte cadeau</h1></div></header>')
  }
}

setTimeout(function() {
  if ($('.container-video-lamat').length) {
    $('.container-video-lamat').clone().insertBefore('.title_product_container');
  }
}, 500);